/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { TextAlignRightJustifyIcon16Light } from './TextAlignRightJustifyIcon16Light';
import { TextAlignRightJustifyIcon16Regular } from './TextAlignRightJustifyIcon16Regular';
import { TextAlignRightJustifyIcon16Solid } from './TextAlignRightJustifyIcon16Solid';
import { TextAlignRightJustifyIcon20Light } from './TextAlignRightJustifyIcon20Light';
import { TextAlignRightJustifyIcon20Regular } from './TextAlignRightJustifyIcon20Regular';
import { TextAlignRightJustifyIcon20Solid } from './TextAlignRightJustifyIcon20Solid';
import { TextAlignRightJustifyIcon24Regular } from './TextAlignRightJustifyIcon24Regular';
import { TextAlignRightJustifyIcon24Solid } from './TextAlignRightJustifyIcon24Solid';
import { TextAlignRightJustifyIcon32Regular } from './TextAlignRightJustifyIcon32Regular';
import { TextAlignRightJustifyIcon64Regular } from './TextAlignRightJustifyIcon64Regular';
var sizes = {
    16: {
        light: TextAlignRightJustifyIcon16Light,
        regular: TextAlignRightJustifyIcon16Regular,
        solid: TextAlignRightJustifyIcon16Solid,
    },
    20: {
        light: TextAlignRightJustifyIcon20Light,
        regular: TextAlignRightJustifyIcon20Regular,
        solid: TextAlignRightJustifyIcon20Solid,
    },
    24: {
        regular: TextAlignRightJustifyIcon24Regular,
        solid: TextAlignRightJustifyIcon24Solid,
    },
    32: {
        regular: TextAlignRightJustifyIcon32Regular,
    },
    64: {
        regular: TextAlignRightJustifyIcon64Regular,
    },
};
export var TextAlignRightJustifyIcon = forwardRef('TextAlignRightJustifyIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
